import React from 'react';

import cn from 'classnames';
import Link from 'next/link';

import { NEWS_PATHS } from '@constants/index'

import styles from './index.module.less';

export const NextPost = (props) => {
  const { className, desc, id, title } = props
  if (!title) {
    return null
  }
  return (
    <div className={cn(styles.container, className)}>
      <p className={styles.desc}>{desc}</p>
      <p>
        <Link legacyBehavior href={`${NEWS_PATHS.POST}/${id}`}>
          <a className={styles.title} data-buried='ZX-10'>
            {title}
          </a>
        </Link>
      </p>
    </div>
  )
}
